export const NeoCmsGameCategoryFeatureNamesEnum = {
    LANDING_PAGES_GAMES_BLOCK: 'landing_pages_games_block',
    SEARCH_TRENDING: 'search_trending',
    PLAY_NEXT_IN_GAME_PAGE: 'play_next_in_game_page',
};
